import { render, staticRenderFns } from "./sectionCreationModal.vue?vue&type=template&id=d18e7032&"
import script from "./sectionCreationModal.vue?vue&type=script&lang=js&"
export * from "./sectionCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports